import Page from "webPage/Page";
import FormValidator from "base/FormValidator";

Page.register(["/"], () => {

    let $form = $('.js-search-form');

    FormValidator.attach($form).on('submit', (e) => {
        $form.find('button[type="submit"]').addClass('btn--loading');
        return false;
    });

});